module.exports = __webpack_public_path__ + "static/media/cisst.0ef04b8b.png";